import PropTypes from "prop-types";

const ProfileDetails = ({ className = "" }) => {
  return (
    <div
      className={`self-stretch h-[220px] flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-left text-base text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="self-stretch flex-1 flex flex-col items-start justify-start gap-5 max-w-full">
        <div className="self-stretch flex-1 rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border flex flex-row items-start justify-start py-[17px] px-[29px] max-w-full">
          <div className="h-[60px] w-[360px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden max-w-full" />
          <input
            className="w-[122px] [border:none] [outline:none] font-text-regular-lowercase text-base bg-[transparent] relative text-dark-text text-left inline-block p-0 z-[1]"
            placeholder="Người Việt Nam"
            type="text"
          />
        </div>
        <div className="self-stretch h-[60px] rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border flex flex-row items-start justify-start py-[17px] px-[29px] max-w-full">
          <div className="h-[60px] w-[360px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden max-w-full" />
          <div className="relative z-[1]">test.email@gmail.com</div>
        </div>
        <div className="self-stretch h-[60px] rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border flex flex-row items-start justify-start py-[17px] px-[29px] max-w-full">
          <div className="h-[60px] w-[360px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden max-w-full" />
          <div className="relative z-[1]">vietnam@1</div>
        </div>
      </div>
    </div>
  );
};

ProfileDetails.propTypes = {
  className: PropTypes.string,
};

export default ProfileDetails;
